import axios from "axios";
import { IPaginationWrapper } from "../models/common";
import { IInboxMessage } from "../models/inboxMessage";

export const getInboxMessages = async (page: number) => {
    const res = await axios.get("/api/inbox", { params: { page: page } });
    return res.data as IPaginationWrapper;
};

export const getInboxMessage = async (guid: string) => {
    const res = await axios.get("/api/inbox/" + guid);
    return res.data as IInboxMessage;
};

export const processInboxMessage = async (guid: string, status: number) => {
    return axios.patch("/api/inbox/" + guid, null, { params: { status: status } });
};

export const getUnreadInboxMessages = async () => {
    const res = await axios.get("/api/inbox/unread");
    return +res.data;
};
